import { FilterMatchMode } from "primereact/api";
import { getContrastTextColor } from "../../utils/FuncionesGenericas";

export class DetalleCandidata {
    constructor() {
        this.model = {
            nombres: {
                header: 'Nombre / Razón Social',
                sort: true,
                filter: true,
                frozen: true,
                matchMode: FilterMatchMode.CONTAINS,
                filterPlaceholder: 'Búsqueda',
                // Aumentamos un poco el ancho y zIndex
                style: { minWidth: '280px', zIndex: '1' },
                body: (rowData) => {
                    return (
                        <div className="flex align-items-center" style={{ marginLeft: '-0.5rem' }}>
                            <div style={{
                                width: '4px',
                                height: '35px',
                                backgroundColor: '#3b82f6',
                                borderRadius: '0 4px 4px 0',
                                marginRight: '12px'
                            }}></div>

                            <div className="flex flex-column">
                                <span className="font-bold text-900" style={{ fontSize: '0.9rem', lineHeight: '1.1' }}>
                                    {rowData.nombres}
                                </span>
                            </div>
                        </div>
                    );
                },
                table: !this.historial
            },
            identificacion: {
                header: 'Identificación',
                table: true,
                sort: true,
                filter: true,
                matchMode: FilterMatchMode.CONTAINS,
                style: { minWidth: '150px' }
            },
            fecha: {
                header: 'Fecha',
                table: true,
                sort: true,
                filter: true,
                isDate: true,
                matchMode: FilterMatchMode.DATE_IS,
                style: { minWidth: '200px' },
                body: (rowData) => {
                    if (!rowData.fecha) return null;
                    return new Date(rowData.fecha + 'T00:00:00').toLocaleDateString(); // Media noche hora local
                }
            },
            proc_aplicado: {
                header: 'Proc. Aplicado',
                table: true,
                sort: true,
                filter: true,
                isMultiselect: true,
                catalogKey: 'procedimientos',
                matchMode: FilterMatchMode.IN,
                style: { minWidth: '200px' }
            },
            alerta_consolidada: {
                header: 'Alerta Consolidada',
                table: true,
                sort: true,
                filter: true,
                isMultiselect: true,
                catalogKey: 'alertas', // Se conectará con el catálogo nivelesAlerta
                matchMode: FilterMatchMode.IN,
                style: { minWidth: '140px', textAlign: 'center' },
                // AQUI USAMOS EL CELLTEMPLATE CON LOS NUEVOS CAMPOS DEL BACKEND
                body: (rowData) => cellTemplate(rowData.aco_alerta_factor, rowData.aco_alerta_color)
            },
            justificacion: {
                header: 'Justificación',
                table: true,
                sort: true,
                filter: true,
                isMultiselect: true,
                catalogKey: 'justificaciones',
                matchMode: FilterMatchMode.IN,
                style: { minWidth: '200px' }
            }
        };
    }
}

const cellTemplate = (valor, colorHex) => {
    if (!valor) return null;
    if (!colorHex) return <span>{valor}</span>;

    const bg = colorHex.startsWith('#') ? colorHex : `#${colorHex}`;
    const fg = getContrastTextColor(bg);
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '100px' }}>
            <span style={{
                backgroundColor: bg, color: fg, padding: '0.25em 0.5em',
                borderRadius: '0.25rem', display: 'inline-block', fontWeight: 'bold', fontSize: '0.9rem'
            }}>
                {valor}
            </span>
        </div>
    );
};